<template>
  <div class="table-view" :class="[$mq]">
    <div
      v-if="filter_visible"
      class="filter-column"
      :class="[filterShow ? 'show' : 'hide', $mq]"
    >
      <div class="filters">
        <div v-for="(item, index) in current_filters" class="filter">
          <div class="title">{{ item.label | i18n }}</div>

          <div
            class="value"
            v-if="
              (typeof item.only_event === 'undefined' ||
                (item.only_event && $store.getters.isEventSelected)) &&
              (typeof item.only_global === 'undefined' ||
                (item.only_global && !$store.getters.isEventSelected))
            "
          >
            <v-checkbox
              color="#8bc34a"
              @change="checkFilter(item)"
              class="filter-checkbox"
              hide-details
              v-if="current_filters_values"
              :value="current_filters_values.hasOwnProperty(item.param)"
            ></v-checkbox>
            <v-text-field
              color="#8bc34a"
              class="filter-input"
              hide-details
              :label="item.label | i18n"
              v-model="current_filters_values[item.param]"
              @input="filterModified(item)"
              outline
              v-if="item.type == 'string'"
              @keyup.enter="
                $event.preventDefault();
                $event.stopPropagation();
                applyFilters();
              "
            ></v-text-field>
            <v-switch
              color="#8bc34a"
              class="filter-input"
              hide-details
              v-model="current_filters_values[item.param]"
              v-if="item.type == 'check'"
              :label="item.label | i18n"
              @change="filterModified(item)"
            ></v-switch>
            <v-select
              color="#8bc34a"
              class="filter-input"
              @change="filterModified(item)"
              hide-details
              v-model="current_filters_values[item.param]"
              v-if="item.type == 'select'"
              :items="getOptions(item.options, item)"
              :label="item.label | i18n"
              @keyup.enter="
                $event.preventDefault();
                $event.stopPropagation();
                applyFilters();
              "
            ></v-select>

            <!-- AUTOCOMPLETE -->
            <v-select
              color="#8bc34a"
              class="filter-input"
              hide-details
              v-if="item.type == 'autocomplete'"
              v-model="current_filters_values[item.param]"
              @change="filterModified(item)"
              :label="item.label | i18n"
              :items="getOptions(item.options, item)"
              autocomplete
              :browser-autocomplete="'asd2saS<'"
              :disabled="item.disabled"
              @keyup.enter="
                $event.preventDefault();
                $event.stopPropagation();
                applyFilters();
              "
            ></v-select>
            <v-select
              color="#8bc34a"
              @change="filterModified(item)"
              class="filter-input"
              hide-details
              v-model="current_filters_values[item.param]"
              v-if="item.type == 'multichoice'"
              :items="getOptions(item.options, item)"
              :label="item.label | i18n"
              :browser-autocomplete="'asd2saS<'"
              multiple
              @keyup.enter="
                $event.preventDefault();
                $event.stopPropagation();
                applyFilters();
              "
            ></v-select>
          </div>
        </div>
      </div>
      <div class="filter-buttons">
        <v-btn @click="applyFilters" depressed class="bttn action do_filter">{{
          "filters.filter" | i18n
        }}</v-btn>
        <v-btn @click="resetFilters" depressed class="bttn reset" small>{{
          "remove" | i18n
        }}</v-btn>
      </div>
      <div
        class="hide-filter"
        :class="[filterShow ? 'show' : 'hide']"
        @click="filterShow = !filterShow"
      >
        <img
          :class="[filterShow ? 'show' : 'hide']"
          src="/img/left-arrow.svg"
        />
      </div>
    </div>
    <div
      class="data-column"
      :class="[!filter_visible ? 'large' : '', filterShow ? 'show' : 'hide']"
    >
      <!-- <v-data-table
        class="datatable-container"
        :headers="headers"
        :items="values"
        :search="search"
        :pagination.sync="pagination"
        :no-data-text="$t('vtf.datatable.no-data')"
        :no-results-text="$t('vtf.datatable.no-data')"
        @page-count="pageCount = $event"
        :rows-per-page-text="''"
        hide-actions
        :headers-length="headers.length + 2"
        group-by="category"
        show-group-by
        fixed-header
      > -->
      <v-data-table
        :class="{
          'datatable-container': true,
          'no-footer': display_options.footer.visible === false,
          'no-header': display_options.header.visible === false,
        }"
        :headers="headers"
        :items="values"
        :search="search"
        :no-data-text="$t('vtf.datatable.no-data')"
        :no-results-text="$t('vtf.datatable.no-data')"
        :pageCount="numberOfPages"
        :options.sync="options"
        :pagination.sync="pagination"
        :page="page"
        :server-items-length="totalValues"
        hide-actions
        :headers-length="headers.length + 2"
        group-by="category"
        show-group-by
        fixed-header
      >
        <template v-slot:headers="props">
          <tr>
            <th class="column col-icon" width="30px" role="columnheader">
              <v-icon @click="filter_visible = !filter_visible">search</v-icon>
            </th>
            <th class="column col-icon" width="30px" role="columnheader">
              <v-icon @click="filterColumns()">view_column</v-icon>
            </th>
            <th
              role="columnheader"
              v-for="header in props.headers"
              :key="header.text"
              :width="header.width ? header.width : '100px'"
              :class="[
                'column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
                header.fixed ? 'fixed-column' : '',
              ]"
              v-show="header.visible"
              @click="
                if (header.sortable && page_sortable) {
                  changeSort(header.value);
                }
              "
              fixed-header
              :title="header.text | i18n"
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text | i18n }}
            </th>
          </tr>
        </template>

        <template v-slot:items="props">
          <template
            v-if="
              typeof props.item.type !== 'undefined' &&
              props.item.type == 'category' &&
              $store.state.current_page == 'competition_scoreboard_phase'
            "
          >
            <tr>
              <td colspan="3" class="table-category">
                {{ props.item.name }}
              </td>
              <td colspan="3" class="table-category">
                <v-switch
                  v-model="props.item.checking"
                  :label="'Classificació provisional'"
                  @change="updateGroup(props.item.id)"
                ></v-switch>
              </td>
              <td :colspan="headers.length - 4" class="table-category"></td>
            </tr>
          </template>
          <template
            v-else-if="
              typeof props.item.type !== 'undefined' &&
              props.item.type == 'category'
            "
          >
            <tr>
              <td :colspan="headers.length + 2" class="table-category">
                {{ props.item.name }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr
              @click="openCard(props.item.id, props.item,$event)"
              class="item"
              :data-id="props.item.id"
            >
              <td class="col-icon" width="30px">
                <!-- <v-icon size="18px">edit</v-icon> -->
              </td>
              <td class="col-icon" width="30px"></td>
              <td
                v-for="(column, index) in headers"
                v-show="column.visible"
                :data-type="column.type"
                :data-value="getValue(props.item, column.value)"
                :class="['column', column.style]"
                @click="
                  if (column.type != 'order') {
                    preview(
                      getValue(props.item, column.value),
                      column.type,
                      $event,
                      props.item.id + '_' + index,
                      props.item
                    );
                  } else return false;
                "
                v-html="
                  format(
                    getValue(props.item, column.value),
                    column.type,
                    props.item.id
                  )
                "
                :id="props.item.id + '_' + index"
              ></td>
            </tr>
          </template>
        </template>
        <!-- <template v-slot:no-results>
                    {{ $t( "vtf.datable.no-data" ) }}
                </template> -->
      </v-data-table>

      <div v-if="display_options.footer.visible === true" id="table-pagination">
        <div class="totalItems">
          {{ "vtf.datatable.total-rows" | i18n }}:
          <span class="total">{{ totalValues }}</span
          ><!--<span class="total">/{{ pagination.totalItems }}</span>-->
        </div>
        <div class="pagination">
          <v-pagination
            v-model="options.page"
            :length="numberOfPages"
          ></v-pagination>
        </div>
        <div class="rows-page">
          <v-select
            :items="rowsPerPage"
            :label="$t('vtf.datatable.rows_page')"
            v-model="options.itemsPerPage"
          ></v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { formatBackofficeGestorType } from "@/constants/backofficeUserTypes.js";

export default {
  name: "Table",
  components: {},
  props: {
    schema: Array,
    data: Object,
    loading: Boolean,
    page_name: String,
    submenu: String,
  },
  data() {
    return {
      pagination: {
        rowsPerPage: [
          //   "event_persons",
          "event_volunteers",
          "volunteers",
          "event_competition_groups",
          "event_competition_calendar",
          "event_competition_scoreboard",
          "event_competition_scoreboard_phase",
          "event_competition_matchs",
          "event_competition_sanctions",
          "event_competition_injuries",
          "event_competition_stats_top_scores",
          "event_competition_stats_team_scores",
        ].includes(this.page_name)
          ? -1
          : 20,
        page: 1,
        totalItems: 0,
        totalFilteredItems: 0,
      },
      rowsPerPage: [10, 20, 50, { text: "Tots", value: -1 }],
      totalValues: 0,
      numberOfPages: 0,
      page: 0,
      options: {
        page: 1,
        itemsPerPage: [
          //   "event_persons",
          "event_volunteers",
          "volunteers",
          "event_competition_groups",
          "event_competition_calendar",
          "event_competition_scoreboard",
          "event_competition_scoreboard_phase",
          "event_competition_matchs",
          "event_competition_sanctions",
          "event_competition_injuries",
          "event_competition_stats_top_scores",
          "event_competition_stats_team_scores",
        ].includes(this.page_name)
          ? -1
          : 20,
      },
      search: "",
      hidden_columns: this.$store.getters["navigation/getCurrentPage"]
        .hidden_columns
        ? this.$store.getters["navigation/getCurrentPage"].hidden_columns
        : [],
      filter_visible: true,
      filters: [],
      // current_filters_values: JSON.parse( JSON.stringify( this.$store.getters[ 'navigation/getCurrentFilters' ] ) ),
      column_preview: false,
      initWidth:
        typeof document.getElementById("container") !== "undefined"
          ? document.getElementById("container").offsetWidth
          : 0,
      filterShow: true,
    };
  },
  computed: {
    page_sortable() {
      return this.page_name == "event_competition_matchs";
    },

    countries() {
      var oCountries = this.$store.getters.getCountries();
      var aResult = [];
      for (var k in oCountries) {
        aResult.push({ text: oCountries[k].name, value: oCountries[k].id });
      }

      return aResult;
    },

    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalFilteredItems == null ||
        this.pagination.totalFilteredItems == 0 ||
        this.pagination.rowsPerPage == -1
      ) {
        return 1;
      }

      return Math.ceil(
        this.pagination.totalFilteredItems / this.pagination.rowsPerPage
      );
    },

    events() {
      //   return this.$store.getters["getEvents"];
    },

    role_volunteer() {
      return this.$store.getters["getRoleVolunteer"];
    },

    current_filters_values() {
      var filters_values = JSON.parse(
        JSON.stringify(this.$store.getters["navigation/getCurrentFilters"])
      );

      for (var k in filters_values) {
        if (filters_values[k] == "{USER_ID}") {
          filters_values[k] = this.$store.getters["user/getUser"].id;
        }
        if (filters_values[k] == "{COMPETITION_CATEGORY_ID}") {
          filters_values[k] =
            this.$store.getters["competition/getCategorySelected"];
        }
      }
      return filters_values;
    },

    headers: {
      get: function () {
        var headers = [];
        var width = 0;
        var visibleH = 0;
        // var currentWidth = ( typeof document.getElementById( 'container' ) !== 'undefined' )? document.getElementById( 'container' ).offsetWidth : 0;

        if (typeof this.schema !== "undefined") {
          var self = this;
          this.schema.forEach((raw) => {
            // console.log(this.hidden_columns.indexOf(raw.id));
            // console.log( raw )
            if (
              raw.type != 8 &&
              raw.type != 9 &&
              (typeof raw.only_event === "undefined" ||
                (self.$store.getters.isEventSelected && raw.only_event)) &&
              (typeof raw.only_global === "undefined" ||
                (!self.$store.getters.isEventSelected && raw.only_global))
            ) {
              var column = {
                text: raw.label,
                value: raw.param,
                sortable:
                  typeof raw.sortable !== "undefined" ? raw.sortable : true,
                type: raw.type,
                visible: this.hidden_columns.indexOf(raw.param) == -1,
                blocked: false,
                width: typeof raw.width !== "undefined" ? raw.width : "",
                fixed: typeof raw.fixed !== "undefined" ? raw.fixed : false,
                style: typeof raw.style !== "undefined" ? raw.style : "",
              };
              headers.push(column);
              if (column.visible) visibleH++;

              if (column.width != "" && column.visible) {
                // console.log( column.width );
                if (column.width.indexOf("%") != -1) {
                  width +=
                    this.initWidth /
                    (100 / parseInt(column.width.replace("%", "")));
                } else {
                  width += parseInt(column.width.replace("px", ""));
                }
                // console.log( width );
                // width += ( ( width != "" )? " + " : "" ) + column.width;
              }
            }
          });

          if (width != 0) {
            width += (this.initWidth / headers.length) * headers.length;
            width -=
              document.getElementsByClassName("filter-column")[0] !== undefined
                ? document.getElementsByClassName("filter-column")[0]
                    .offsetWidth
                : 0;
            // console.log( width );
            setTimeout(function () {
              if (
                typeof document.getElementsByClassName("v-table")[0] !==
                "undefined"
              ) {
                document.getElementsByClassName("v-table")[0].style.width =
                  width + "px";
              }
            }, 200);
          } else {
            var self = this;
            var table = document.getElementsByClassName("v-table")[0];
            // var tds = table.children[1].children[0].children;
            // var widthH = offsetWidth / visibleH;

            setTimeout(function () {
              var offsetWidth =
                document.getElementsByClassName("v-table__overflow")[0]
                  .offsetWidth;
              document.getElementsByClassName("v-table")[0].style.width =
                offsetWidth + "px";
            }, 200);
          }

          // console.log( headers );
        }

        return headers;
      },
      set: function (value) {
        // console.log("SET HEADERS " + value)
        this.headers = value;
      },
    },
    values() {
      var values = [];
      // console.log( this.data );
      for (var i in this.data.data) {
        var row = this.data.data[i];

        values.push(row);
      }
      //   console.log( values );
      this.pagination.totalFilteredItems = values.length;
      var page = this.page_name.replace("event_", "");
      page = page.replace("_", "/");
      //   this.pagination.totalItems = this.$store.getters[
      //     page + "/getListNoFiltered"
      //   ]().length;
      this.totalValues = this.data.total;
      this.numberOfPages = parseInt(
        parseInt(this.data.total) / this.options.itemsPerPage
      );
      if (parseInt(this.data.total) % this.options.itemsPerPage != 0) {
        this.numberOfPages++;
      }

      if (!this.loading) this.$overlay.hide();

      return this.page_sortable ? values : this.sortTable(values);
    },
    current_filters() {
      if (
        typeof this.$store.getters["navigation/getCurrentPage"].filters ===
        "undefined"
      ) {
        return {};
      }

      var filters = JSON.parse(
        JSON.stringify(this.$store.getters["navigation/getCurrentPage"].filters)
      );
      this.filters = filters;
      // console.log( "CURRENT_FILTERS" );
      return filters;
    },
    display_options() {
      var options = {
        header: {
          visible: true,
        },
        footer: {
          visible: true,
        },
      };

      var custom_options = {};

      if (
        typeof this.$store.getters["navigation/getCurrentPage"].display !==
        "undefined"
      ) {
        custom_options =
          this.$store.getters["navigation/getCurrentPage"].display;
      }

      if (custom_options.header) options.header = custom_options.header;
      if (custom_options.footer) options.footer = custom_options.footer;

      return options;
    },
  },
  methods: {
    openCard(id, data, event) {
      var page = this.page_name.replace("event_", "");
      if (page == "events") {
        var url = this.$root.formatEventUrl(data.name, data.edition);
        this.$router.push(url);
      } else if (page == "finances") {
        if (this.submenu == "payments") {
          var entity = document
            .getElementById(id + "_3")
            .getElementsByClassName("entity")[0].classList[1];
          var entity_id = document
            .getElementById(id + "_3")
            .getElementsByClassName("entity")[0].dataset["id"];
          var page = "";
          switch (entity) {
            case "2":
              page = "teams";
              break;
            case "3":
              page = "participants";
              break;
          }

          var url_name = page + "_card";
          var oParams = { id: entity_id };

          if (this.$store.state.event_selected) {
            url_name = "event_" + url_name;
            oParams.event = this.$route.params.event;
          }

          this.$router.push({ name: url_name, params: oParams });
          this.$destroy();
        } else if (this.submenu == "prices" || this.submenu == "discounts") {
        } else {
          var transaction = {
            ...this.$store.getters["finances/get_transaction_by_id"](id),
          };
          this.$card.finances(transaction);
        }
      } else if (this.$store.state.current_page == "participants") {
        //console.log(this.$route.params.event);
        this.$router.push({
          name: "event_participants_card",
          params: { id: id, event: this.$route.params.event },
        });
        this.$emit("destroy");
        this.$destroy();
      } else if (this.page_name == "event_competition_groups") {
        var self = this;
        //console.log(id, data);
        this.$card.assignTeamToTmpl({
          tmpl_team_id: id.substring(2),
          team_id: data.team != null ? data.team.id : -1,
          item: data,
          event_id: self.$store.getters["events/getCurrentEvent"]().id,
          callBack: function (plug, params, store) {
            //console.log(plug);
            self.$store
              .dispatch("competition/assignTeamToTmpl", {
                team_id: plug.params.team.value,
                tmpl_team_id: plug.params.tmpl_team.value,
                item: plug.params.item,
              })
              .then(function () {
                self.$popup.alert({
                  message: i18n.t("competition.group.assign_team_to_tmpl"),
                  btnSuccess: i18n.t("accept"),
                });
                self.$card.close();
                self.$emit("reload");
              })
              .catch(function (e) {
                self.$popup.alert({
                  message: i18n.t("errors." + e),
                  btnSuccess: i18n.t("accept"),
                });
                self.$card.close();
              });
          },
        });
      } else if (this.page_name == "event_competition_calendar") {
        var self = this;
        
        if(event.target.classList.contains('competition_phase_visible') ||event.target.classList.contains('competition_phase_visible_checkbox')) {
            self.$store.dispatch("competition/changePhaseVisibility", {
                phase_id: id,
                is_visible: !data.is_visible
            })
        } else {
            self.$store.commit("competition/changeCategory", data.category_id);
                this.$router.push({
                name: "event_competition_matchs",
                params: { phase_id: id, category_id: data.category_id },
            });
        }
        // this.$destroy();
      } else if (this.page_name == "event_competition_matchs") {
        var self = this;
        
        this.$router.push({
            name: "event_competition_matchs_edit",
            params: { phase_id: self.$route.params.phase_id, id: id },
        });
        this.$destroy();
      } else if (this.page_name == "event_competition_scoreboard") {
        var self = this;
        this.$router.push({
          name: "event_competition_scoreboard_phase",
          params: { phase_id: id },
        });
        // this.$destroy();
      } else if (this.page_name == "event_competition_sanctions") {
        var self = this;
        this.$router.push({
          name: "event_competition_sanctions_edit",
          params: { event: this.$route.params.event, id: id },
        });
        // this.$destroy();
      } else if (this.page_name == "event_competition_scoreboard_phase") {
      } else if (this.page_name == "event_confirmations") {
        var self = this;
        this.$router.push({
          name: "event_teams_card",
          params: { event: this.$route.params.event, id: id },
        });
      } else {
        var url_name = page + "_card";
        var oParams = { id: id };

        if (this.$store.state.event_selected) {
          url_name = "event_" + url_name;
          oParams.event = this.$route.params.event;
        }

        this.$router.push({ name: url_name, params: oParams });
        this.$destroy();
      }
    },

    filterColumns() {
      var self = this;
      this.$filter({
        list: this.headers,
        selected: self.hidden_columns,
        left: this.filter_visible ? "20%" : 0,
        callback: function (d) {
          self.hidden_columns = [...d];
          self.saveFilter(self.hidden_columns);
        },
      });
      this.$filter.show();
    },

    checkFilter(item) {
      var filters = { ...this.current_filters_values };

      if (filters.hasOwnProperty(item.param)) {
        delete filters[item.param];
      } else {
        filters[item.param] = item.current_value;
        // switch (item.type) {
        //   case 'string':
        //     break;
        // }
      }

      this.$store.commit("navigation/setCurrentFilters", {
        page: this.$store.getters.getCurrentPage,
        event: this.$store.getters.isEventSelected,
        filters: filters,
      });
    },

    filterModified(item) {
      var filters = { ...this.current_filters_values };

      for (var index in filters) {
        if (filters[index] == item.current_value) {
          delete filters[index];
        } else if (!filters.hasOwnProperty(index)) {
          filters.index = item.current_value;
        }
      }

      this.$store.commit("navigation/setCurrentFilters", {
        page: this.$store.getters.getCurrentPage,
        event: this.$store.getters.isEventSelected,
        filters: filters,
      });
    },

    saveFilter(filter) {
      this.$store.commit("navigation/setHiddenColumns", filter);
      // if(localStorage) {
      // 	localStorage.col_register = JSON.stringify(filter);
      // }
    },

    changeSort(column) {
      let pagination = { ...this.pagination };
      if (pagination.sortBy == column) {
        pagination.descending = !pagination.descending;
      } else {
        pagination.sortBy = column;
        pagination.descending = false;
      }

      this.pagination = { ...pagination };
    },

    sendAddedit(id, e) {
      e.preventDefault();
      e.stopPropagation();
      var page = this.page_name.replace("event_", "");
      if (page == "events") {
        var url = this.$root.formatEventUrl(data.name, data.edition);
        this.$router.push(url);
      } else if (page == "finances") {
        var transaction = {
          ...this.$store.getters["finances/get_transaction_by_id"](id),
        };
        this.$card.finances(transaction);
      } else {
        var url_name = page + "_edit";
        var oParams = { id: id };

        if (this.$store.state.event_selected) {
          url_name = "event_" + url_name;
          oParams.event = this.$route.params.event;
        }

        this.$router.push({ name: url_name, params: oParams });
      }
    },

    handlePhaseVisibilityClick(phase_id) {
      alert(phase_id)
    },
    getBusServiceLabel(transferOptions) {
      if (!transferOptions || transferOptions === 'null' || transferOptions.trim() === '') {
        return i18n.t('nsnc')
      }

      let opts
      try {
        opts = JSON.parse(transferOptions)
      } catch (e) {
        return 'Invalid data'
      }

      const wantBus = opts.want_bus_service
      const type = opts.bus_service_type

      if (!wantBus) return i18n.t('nsnc')
      if (wantBus === 'no') return i18n.t('transfer.no_bus_service')

      if (wantBus === 'yes') {
        switch (type) {
          case 'arrival':
            return i18n.t('transfer.bus_arrival_only')
          case 'departure':
            return i18n.t('transfer.bus_departure_only')
          case 'both':
            return i18n.t('transfer.bus_arrival_departure')
          case 'other':
            return i18n.t('transfer.bus_other_days')
          default:
            return i18n.t('transfer.bus_service_requested')
        }
      }

      return i18n.t('nsnc')
    },
    format(value, type, id_parent) {
      // console.log( value );
      // console.log( value );
      // console.log( type );
      //   console.log( id_parent );
      var event = this.$store.getters["events/getCurrentEvent"]();
      let coin =  event.type_id == 15 ? '$' : '€'
      switch (type + "") {
        case "string":
          return value;
        case "hotel_completion":
          let newVal = `${value}`
          let complete = "competition.sanction.status.completed"
          let pending = "competition.sanction.status.pending"
          let error = "miccamps.match_actions.fail"
          if (newVal === '1') {
            return `<div class="completition-status"><div class="complete"></div>${i18n.t(complete)}</div>`;
          } else if (newVal === '2') {
            return `<div class="completition-status"><div class="error"></div>${i18n.t(error)}</div>`;
          } else {
            return `<div class="completition-status"><div class="pending"></div>${i18n.t(pending)}</div>`;
          }
        case "bus_service_type":
          return this.getBusServiceLabel(value)
        case "number":
          return value != null ? value : 0;
        case "string_translate":
          return i18n.t(value);
        case "competition_phase":
            let phase = this.$store.getters["competition/getListPhases"](id_parent)
            if(phase.name.match(/groups/)) return "<div class='competition_phase'>" + i18n.t(value) + "</div>"
          return value ? "<div class='competition_phase'>" + i18n.t(value) + "</div><div data-id='" + id_parent + "' class='competition_phase_visible' ><input class='competition_phase_visible_checkbox' name='phase_visible' data-id='" + id_parent + "' type='checkbox' " + (phase.is_visible ? "checked='checked'" : "") + "'/> Mostrar en Miclive</div>" : "";
        case "image":
          return value ? '<img src="' + value + '"/>' : value;
        case "country":
          var country = this.$store.getters.getCountryByID(value);
          // return ( country )? '<div class="country"><img src="'+country.flag+'"/><span class="label">'+country.abbreviation+'</span></div>' : "";
          return country
            ? '<div class="country">' + country.name + "</div>"
            : "";
        case "empty":
          return " ";
        case "date":
          //if (value) console.log("DATE -> ", value);
          return value ? moment(value).format("DD/MM/YYYY") : "";
        case "date_hour":
          return moment(value).format("DD/MM/YYYY HH:mm") !=
            moment("00/00/0000 00:00").format("DD/MM/YYYY HH:mm")
            ? moment(value).format("DD/MM/YYYY HH:mm")
            : "-";
        case "hour":
          //if (value) console.log("HOUR -> ", value);
          return value ? moment(value).format("HH:mm") : "";
        case "status":
          return value == 1 ? "" : '<img src="/img/error.svg"/>';
        case "status_transaction":
          return value == 1
            ? i18n.t("finances.import.assigned")
            : i18n.t("finances.import.slope");
        case "payment":
          return value == 0 ? "TPV" : "Transfer";
        case "role":
          return (
            "<div class='role r" +
            value.id +
            "'><div class='icon'></div>" +
            i18n.t(value.name) +
            "</div>"
          );
        case "user_bo_type": {
          const v = parseInt(value, 10);
          return formatBackofficeGestorType(v);
        }
        case "user_mic_status": {
          const s = parseInt(value, 10);
          if (s === 1) {
            return "Actiu";
          }
          if (s === -2) {
            return "Inactiu";
          }
          if (s === -1) {
            return "Eliminat";
          }
          return "";
        }
        case "import":
          return `${value} ${coin}`;
        case "entity":
          if (value === undefined || value == null || value.type == null) {
            return i18n.t("not_role");
          }
          return (
            "<div class='entity " +
            value.type +
            "' data-id='" +
            value.id +
            "'>" +
            (typeof value.shield !== "undefined"
              ? "<img class='logo' src='" + value.shield + "'></img>"
              : "") +
            (value.type != "event"
              ? value.name
              : this.$root.formatEventName(value.name, value.edition)) +
            "</div>"
          );
        case "tmpl_team":
          if (!value) return "";
          else if (value.team === undefined || value.team == null) {
            return value.name;
          }
          return (
            "<div class='entity 2 " +
            (value.winner ? "winner" : "") +
            "' data-id='" +
            value.team.id +
            "'>" +
            (typeof value.team.shield !== "undefined"
              ? "<img class='logo' src='" + value.team.shield + "'></img>"
              : "") +
            value.team.name +
            "</div>"
          );
        case "assign_team":
          if (value === undefined || value == null) return i18n.t("not_role");
          return (
            "<div class='entity " +
            value.type +
            "' data-id='" +
            value.id +
            "'>" +
            (typeof value.shield !== "undefined"
              ? "<img class='logo' src='" + value.shield + "'></img>"
              : "") +
            (value.type != "event"
              ? value.name
              : this.$root.formatEventName(value.name, value.edition)) +
            "</div>"
          );
        case "club":
          return (
            "<div class='entity club'><img class='logo' src='" +
            value.shield +
            "'></img>" +
            value.name +
            "</div>"
          );
        case "category":
          return "<div class='entity category'>" + value.max_age + "</div>";
        case "event_status":
          var status = this.$store.getters["events/getStatusEntityByID"](value);
          var html =
            "<div class='status event s" +
            value +
            "' ><div class='icon' style='background-color:" +
            (status ? status.color : "#FFF") +
            "'></div>" +
            (status ? i18n.t(status.name) : "") +
            "</div>";
          return html;
        case "event_status_disabled":
          var status = this.$store.getters["events/getStatusEntityByID"](value);
          var html =
            "<div class='status event disabled s" +
            value +
            "' ><div class='icon' style='background-color:" +
            (status ? status.color : "#FFF") +
            "'></div>" +
            (status ? i18n.t(status.name) : "") +
            "</div>";
          return html;
        case "user":
          var user =
            value == null
              ? i18n.t("clubs.not_assign")
              : this.$store.getters["user/getList"](value).name;
          var html = "<div class='user event'>" + user + "</div>";
          return html;
        case "boolean":
          return value == true || value == 1 || value == "true"
            ? i18n.t("bool.si")
            : i18n.t("bool.no");
        case "logo_event":
          return value
            ? '<img src="' +
                value.logo +
                '" class="logo_event" style="background:' +
                value.color +
                '"/>'
            : value;
        case "categories":
          var cat = "";
          if (
            typeof value === "undefined" ||
            value == null ||
            value == "null" ||
            !value
          ) {
            return "";
          }
          value.forEach((category) => {
            if (cat != "") cat += ",";
            cat += category.max_age;
          });
          return cat;
        case "campus":
          var camp = "";
          value.forEach((campus) => {
            if (camp != "") camp += "<br>";
            var name = campus.name;
            
            if (event.type_id == 12) {
              name = name.split(".");
              name = name[0] + "." + name[1] + "." + name[2] + "_" + name[3];
            }
            camp +=
              i18n.t(name) +
              " " +
              moment(campus.start_date).format("DD/MM/YYYY") +
              " - " +
              moment(campus.end_date).format("DD/MM/YYYY");
          });
          return camp;
        case "team_user":
          var user =
            value.gestor_id == null
              ? i18n.t("clubs.not_assign")
              : this.$store.getters["user/getList"](value.gestor_id)
              ? this.$store.getters["user/getList"](value.gestor_id).name
              : "";
          var html = "<div class='user event no_modify'>" + user + "</div>";
          return html;
        case "campus_finances":
          return value ? value.payed + coin +" / " + value.total + coin : value;
        case "budget_total":
          return value
            ? "<div class='budget " +
                (value.total > value.payed ? "pending" : "complete") +
                "'>" +
                value.total +
                coin +
                "</div>"
            : "0" + coin;
        case "budget_payed":
          var sClass = "complete";
          if (value.total > value.payed) sClass = "pending";
          else if (value.total < value.payed) sClass = "over";
          return value
            ? "<div class='budget " +
                sClass +
                "'>" +
                value.payed +
                coin +
                "</div>"
            : "0" + coin;
        case "budget_pay":
          var sClass = "complete";
          if (value.total > value.payed) sClass = "pending";
          else if (value.total < value.payed) sClass = "over";

          return value && value.total >= value.payed
            ? "<div class='budget " +
                sClass +
                "'>" +
                (value.total - value.payed) +
                coin +
                "</div>"
            : "<div class='budget " + sClass + "'>" + "0" + coin + "</div>";
        case "budget_passpay":
          return value && value.total < value.payed
            ? "<div class='budget over'>" +
                (value.payed - value.total) +
                coin + "</div>"
            : "0" + coin;
        case "location":
          if (
            (value && value.entity_type != undefined) ||
            value.entity_type != null
          ) {
            switch (value.entity_type) {
              case "4":
                return this.$store.getters["hotels/get_by_id"](value.entity_id)
                  .name;
              case "5":
                return this.$store.getters["facilitys/get_by_id"](
                  value.entity_id
                ).name;
              case "11":
                return this.$store.getters["travels/get_location_by_id"](
                  value.entity_id
                ).name;
              default:
                return value.name;
            }
          } else {
            return value.name;
          }
        case "transport_mode":
          return value != null
            ? i18n.t(
                "travels.transport_mode." +
                  this.$store.getters.getTransportMode()[value].name
              )
            : i18n.t("undefined");
        case "travel_type":
          return value != 0
            ? i18n.t("travels.travel_type_" + value)
            : i18n.t("undefined");
        case "price_category":
          return i18n.t(this.$store.state.service_type[value].name);
        case "participant_status":
          var status = this.$store.getters.getStatusParticipants(value);
          var html =
            "<div class='status participant'>" +
            (status ? i18n.t(status.name) : "") +
            "</div>";
          return html;

        case "lottery_send":
          var status = value == "1" ? "si" : "no";
          var html =
            "<div class='status lottery_send'>" +
            (status ? i18n.t(status) : "") +
            "</div>";
          return html;
        case "events_name":
          if (value == null) {
            return "-";
          } else {
            var html = "<span>";
            var self = this;
            for (var item of value) {
              var event2 = self.$store.getters["events/getList"](item.id[0]);
              //   console.log("events_name", item.id, event);
              if (event2) {
                html += " " + event2.name + " " + event2.edition;
                html += "<br>";
              } else {
              }
            }

            html += "</span>";

            return html;
          }
        case "events_work":
          if (value == null) {
            return "-";
          } else {
            var html = "<span>";
            var self = this;
            for (var item of value) {
              var event2 = self.$store.getters["events/getList"](item.id[0]);
              if (event2) {
                // GET ROLES FOR EVENT
                for (var subitem of item.role) {
                  if (this.role_volunteer[subitem] != undefined) {
                    var role = i18n.t(
                      "role_volunteer_event." +
                        this.role_volunteer[subitem].name
                    );
                    html += " " + role;
                  } else {
                    html += " ";
                  }
                }
                html += "<br>";
              } else {
              }
            }

            html += "</span>";

            return html;
          }

        case "idiomas":
          if (value == null) {
            return "-";
          } else {
            var html = "<span>";
            typeof value === "string"
              ? (value = JSON.parse(value.split(",")[0] + ',"level":"Alt"}]'))
              : true;
            var lang = false;

            var languages = this.$store.getters.getLanguageVolunteer;
            for (var item of value) {
              if (!lang) {
                lang = true;
              } else {
                html += "<br>";
              }
              var lang = i18n.t(
                "language_volunteer." + languages[item.lang].name
              );
              var level = item.level;
              html += " " + lang + " - " + level;
            }

            html += "</span>";

            return html;
          }
        case "lang":
          if (value == null) {
            return "-";
          } else {
            var html = "<span>";

            var languages = this.$store.getters.getLanguages;
            var lang = languages[value].name;
            switch (lang) {
              case "ca":
                lang = "cat";
                break;
              case "es":
                lang = "spa";
                break;
              case "en":
                lang = "eng";
                break;
            }

            html += i18n.t("language_volunteer." + lang);

            html += "</span>";

            return html;
          }
        case "campus_position":
          if (value == null) {
            return "-";
          } else {
            var html = "<span>";

            var goalkeeper = value == "1" || value == 1;

            html += i18n.t(
              goalkeeper ? "params.goalkeeper" : "params.field_player"
            );

            html += "</span>";

            return html;
          }
        case "document":
          return value != null
            ? i18n.t(
                this.$store.getters["persons/getStatusDocuments"](value).name
              )
            : i18n.t("documents.status_0");
        case "mode":
          var modes = this.$store.getters["getModeRegistered"]();
          var oMode = false;
          modes.forEach((mode) => {
            if (mode.id == value) oMode = mode;
          });
          return oMode ? i18n.t(oMode.name) : i18n.t("undefined");
        case "insured":
          var insured = [
            { value: "0", text: "nsnc" },
            { value: "1", text: "si" },
            { value: "2", text: "no" },
          ];
          return insured[parseInt(value)]
            ? i18n.t(insured[parseInt(value)].text)
            : " - ";
        case "diet":
          return value != null &&
            typeof this.$store.state.diet[value] !== "undefined"
            ? i18n.t(this.$store.state.diet[value].name)
            : i18n.t("-");
        case "shirt_size":
          return value != null && typeof this.$store.state.volunteer_shirt_size[value] !== "undefined"
            ? i18n.t(this.$store.state.volunteer_shirt_size[value].name)
            : i18n.t("-");
        case "shoes_size":
          if (value != null) {
            var shoe_size =
              i18n.t(this.$store.state.volunteer_shoes_size[value].ue) + " ";
            if (this.$store.state.volunteer_shoes_size[value].sex == "1") {
              shoe_size += i18n.t("man");
            } else {
              shoe_size += i18n.t("woman");
            }
            return shoe_size;
          } else {
            return i18n.t("-");
          }
        case "how_meet":
          return value != null
            ? i18n.t(this.$store.getters.getHowMeet(value).name)
            : i18n.t("-");
        case "allergy":
          if (value == null || value == "null") return "-";
          var alergy_text = "";
          if (value != "") {
            var alergies = this.$store.state.persons.alergies;
            value.split(",").forEach((alergy) => {
              if (alergy != "null" && alergy != null) {
                alergy_text += alergy_text != "" ? "," : "";
                alergy_text += i18n.t(alergies[parseInt(alergy)].name);
              }
            });
          }
          return alergy_text;
        case "pax":
          if (value == null) {
            return "-";
          } else {
            var html = "<span>";
            for (var i in value) {
              var item = value[i];
              //console.log("pax -> ", item);
              if (html != "") html += "<br>";
              if (item.entity_type == "2") {
                html +=
                  "<div class='entity club'><img class='logo' src='" +
                  item.shield +
                  "'></img>" +
                  item.name +
                  " - " +
                  item.category +
                  " / Gestor: " +
                  (this.$store.getters["user/getList"](item.gestor_id)
                    ? this.$store.getters["user/getList"](item.gestor_id).name
                    : "-") +
                  "</div>";
              } else {
                html += item.name;
              }
            }

            html += "</span>";

            return html;
          }
        case "campus_code":
          //console.log(value);
          if (value == null) {
            return "-";
          } else {
            return value;
          }
        case "hotel_category":
          return value != null
            ? i18n.t(this.$store.getters["hotels/getCategories"](value).name)
            : "-";
        case "room":
          if (!value && value.a == null && value.b == null) return "-";
          else {
            value.a = value.a == null ? 0 : parseInt(value.a);
            value.b = value.b == null ? 0 : parseInt(value.b);
            return (
              '<span class="used' +
              (value.b > value.a ? " overbooking" : "") +
              '">' +
              value.b +
              "</span> / " +
              value.a
            );
          }
        case "rooming_hotel":
          if (value == null || value.hotel == null) return "-";
          return value.hotel.name;
        case "status_match": {
          if (value == null) return "-";

          var status = this.$store.getters["events/getStatusEntityByID"](value);
          var color = "#ccc";
          switch (parseInt(value)) {
            case 1:
              color = "#ccc";
              break;
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
              color = "#ffc107";
              break;
            case 8:
              color = "#ff5722";
              break;
            case 9:
              color = "#4caf50";
              break;
          }

          var html =
            "<div class='status disabled match s" +
            value +
            "' ><div class='icon' style='background-color:" +
            color +
            "'></div>" +
            i18n.t(
              this.$store.getters["competition/matchs/statusToString"](
                parseInt(value)
              )
            ) +
            "</div>";

          return html;

          /* return i18n.t(
            this.$store.getters["competition/matchs/statusToString"](
              parseInt(value)
            )
          ); */
        }
        case "bus_campus": {
          if (value == null) return "-";
          switch (parseInt(value)) {
            case 0:
              return "NO";
            case 1:
              return "Anada";
            case 2:
              return "Tornada";
            case 3:
              return "Anada i tornada";
          }
        }
        case "bus_campus_pickup": {
          //console.log("pickup", value);
          if (value == null) return "-";
          var options = this.$store.getters.getPickUpOptions();
          switch (parseInt(value)) {
            case 0:
              return "NO";
            default:
              return i18n.t(options[value].name);
          }
        }
        case "last_update": {
          if (value == null || !value.date) return "-";
          return value.date;
        }
        case "division_id": {
          if (value == null) return "-";

          var divisions = this.$store.getters.getTeamDivision();
          if (divisions[value]) return divisions[value].name;
          return "-";
        }
        case "order": {
          return (
            '<span class="value">' +
            value +
            '</span><div class="icon arrow-up"></div><div class="icon arrow-down"></div>'
          );
        }
        default:
          return value;
      }
    },
    preview(value, type, e, id, item) {
      //console.log(value);
      //console.log(id);
      if (this.column_preview) {
        this.column_preview = false;
        e.preventDefault();
        e.stopPropagation();
        this.$comboSelector.close();
      } else {
        this.column_preview = true;
        switch (type) {
          case "event_status":
            e.preventDefault();
            e.stopPropagation();
            var entity = -1;
            var page = this.$store.getters.getCurrentPage.replace("event_", "");
            switch (page) {
              case "clubs":
                entity = 1;
                break;
              case "teams":
                entity = 2;
                break;
              case "persons":
                entity = 3;
                break;
              case "participants":
                entity = 10;
                break;
              case "club":
                entity = 1;
                break;
              case "volunteers":
                entity = 30;
                break;
            }
            var aStatus = [
              ...this.$store.getters["events/getStatusEntities"]({
                entity: entity,
              }),
            ];
            //console.log(aStatus);
            var elem = document.getElementById(id);
            var rect = elem.childNodes[0].getBoundingClientRect();
            var style = elem.childNodes[0].style;

            var self = this;
            this.$comboSelector({
              values: aStatus,
              current: value,
              style: {
                top: rect.bottom,
                left: rect.left,
                width: rect.width,
                backgroundColor: style.backgroundColor,
                color: style.color,
              },
              callBackClose: function () {
                self.column_preview = false;
                self.$comboSelector.close();
              },
              callBackSave: function (status) {
                var status1 = "";
                var status2 = "";
                for (var k in aStatus) {
                  var stat = aStatus[k];
                  if (stat.id == value) status1 = stat.name;
                  else if (stat.id == status) status2 = stat.name;
                }

                self.$popup.confirm(
                  {
                    message: i18n
                      .t(page + ".change_status")
                      .replace("{status1}", i18n.t(status1))
                      .replace("{status2}", i18n.t(status2)),
                    btnSuccess: i18n.t("accept"),
                    btnError: i18n.t("cancel"),
                  },
                  function () {
                    self.$overlay.loading();
                    var path =
                      page != "participants"
                        ? page + "/changeStatus"
                        : "persons/changeStatusParticipant";
                    self.$store
                      .dispatch(path, {
                        id: id.split("_")[0],
                        event_id:
                          self.$store.getters["events/getCurrentEvent"]().id,
                        status: status,
                      })
                      .then(function () {
                        self.column_preview = false;
                        self.$comboSelector.close();
                        self.$emit("reload");
                        self.$store
                          .dispatch(
                            "events/loadByName",
                            self.$route.params.event
                          )
                          .then(function () {
                            self.$overlay.hide();
                          });
                      });
                  },
                  function () {
                    self.column_preview = false;
                    self.$comboSelector.close();
                  }
                );
              },
            });

            break;
          case "user":
            e.preventDefault();
            e.stopPropagation();

            var aUsers = [...this.$store.getters["user/getList"]()];
            aUsers = aUsers.filter((user) => {
              return user.type < 3;
            });
            var oEvent = this.$store.getters["events/getCurrentEvent"]();
            //console.log(aUsers);
            var elem = document.getElementById(id);
            var rect = elem.childNodes[0].getBoundingClientRect();
            var style = elem.childNodes[0].style;

            var self = this;
            var page = this.$store.getters.getCurrentPage.replace("event_", "");
            this.$comboSelector({
              values: aUsers,
              current: value,
              style: {
                top: rect.bottom,
                left: rect.left,
                width: rect.width,
                backgroundColor: style.backgroundColor,
                color: style.color,
              },
              callBackClose: function () {
                self.column_preview = false;
                self.$comboSelector.close();
              },
              callBackSave: function (user) {
                var user1 = "";
                var user2 = "";
                for (var k in aUsers) {
                  var usr = aUsers[k];
                  if (usr.id == value) user1 = usr.name;
                  else if (usr.id == user) user2 = usr.name;
                }

                self.$popup.confirm(
                  {
                    message: i18n
                      .t(page + ".change_user")
                      .replace("{user1}", user1)
                      .replace("{user2}", user2),
                    btnSuccess: i18n.t("accept"),
                    btnError: i18n.t("cancel"),
                  },
                  function () {
                    self.$overlay.loading();
                    self.$store
                      .dispatch(page + "/changeUser", {
                        id: id.split("_")[0],
                        gestor_id: user,
                        event_id: oEvent.id,
                      })
                      .then(function () {
                        self.column_preview = false;
                        self.$comboSelector.close();
                        self.$overlay.hide();
                      });
                  },
                  function () {
                    self.column_preview = false;
                    self.$comboSelector.close();
                  }
                );
              },
            });

            break;
          case "volunteer_status":
            e.preventDefault();
            e.stopPropagation();
            var entity = -1;
            var page = this.$store.getters.getCurrentPage.replace("event_", "");
            switch (page) {
              case "clubs":
                entity = 1;
                break;
              case "teams":
                entity = 2;
                break;
              case "persons":
                entity = 3;
                break;
              case "hotels":
                entity = 1;
                break;
              case "club":
                entity = 1;
                break;
            }
            var aStatus = { ...this.$store.getters["getStatusVolunteer"] };
            var elem = document.getElementById(id);
            var rect = elem.childNodes[0].getBoundingClientRect();
            var style = elem.childNodes[0].style;

            var self = this;
            this.$comboSelector({
              values: aStatus,
              current: value,
              style: {
                top: rect.bottom,
                left: rect.left,
                width: rect.width,
                backgroundColor: style.backgroundColor,
                color: style.color,
              },
              callBackClose: function () {
                self.column_preview = false;
                self.$comboSelector.close();
              },
              callBackSave: function (status) {
                var status1 = "";
                var status2 = "";
                for (var k in aStatus) {
                  var stat = aStatus[k];
                  if (stat.id == value) status1 = stat.name;
                  else if (stat.id == status) status2 = stat.name;
                }

                self.$popup.confirm(
                  {
                    message: i18n
                      .t(page + ".change_status")
                      .replace("{status1}", i18n.t(status1))
                      .replace("{status2}", i18n.t(status2)),
                    btnSuccess: i18n.t("accept"),
                    btnError: i18n.t("cancel"),
                  },
                  function () {
                    self.$overlay.loading();
                    self.$store
                      .dispatch(page + "/changeStatus", {
                        id: id.split("_")[0],
                        status: status,
                      })
                      .then(function () {
                        self.column_preview = false;
                        self.$comboSelector.close();
                        self.$store
                          .dispatch(
                            "events/loadByName",
                            self.$route.params.event
                          )
                          .then(function () {
                            self.$overlay.hide();
                          });
                      });
                  },
                  function () {
                    self.column_preview = false;
                    self.$comboSelector.close();
                  }
                );
              },
            });

            break;

          case "participant_status":
            e.preventDefault();
            e.stopPropagation();

            var aStatus = {
              ...this.$store.getters.getStatusParticipants(),
            };
            //console.log(aStatus);
            var elem = document.getElementById(id);
            var rect = elem.childNodes[0].getBoundingClientRect();
            var style = elem.childNodes[0].style;

            var self = this;
            this.$comboSelector({
              values: aStatus,
              current: value,
              style: {
                top: rect.bottom,
                left: rect.left,
                width: rect.width,
                backgroundColor: style.backgroundColor,
                color: style.color,
              },
              callBackClose: function () {
                self.column_preview = false;
                self.$comboSelector.close();
              },
              callBackSave: function (status) {
                var status1 = "";
                var status2 = "";
                for (var k in aStatus) {
                  var stat = aStatus[k];
                  if (stat.id == value) status1 = stat.name;
                  else if (stat.id == status) status2 = stat.name;
                }

                self.$popup.confirm(
                  {
                    message: i18n
                      .t("participants.change_status")
                      .replace("{status1}", i18n.t(status1))
                      .replace("{status2}", i18n.t(status2)),
                    btnSuccess: i18n.t("accept"),
                    btnError: i18n.t("cancel"),
                  },
                  function () {
                    self.$overlay.loading();
                    var path = "persons/changeStatusParticipantEvent";
                    self.$store
                      .dispatch(path, {
                        id: id.split("_")[0],
                        event_id:
                          self.$store.getters["events/getCurrentEvent"]().id,
                        status: status,
                      })
                      .then(function () {
                        self.column_preview = false;
                        self.$comboSelector.close();
                        self.$store
                          .dispatch(
                            "events/loadByName",
                            self.$route.params.event
                          )
                          .then(function () {
                            self.$overlay.hide();
                          });
                      });
                  },
                  function () {
                    self.column_preview = false;
                    self.$comboSelector.close();
                  }
                );
              },
            });

            break;

          case "lottery_send":
            e.preventDefault();
            e.stopPropagation();

            var aStatus = {
              1: { id: "1", name: "Sí" },
              0: { id: "0", name: "No" },
            };
            //console.log(aStatus);
            var elem = document.getElementById(id);
            var rect = elem.childNodes[0].getBoundingClientRect();
            var style = elem.childNodes[0].style;

            var self = this;
            this.$comboSelector({
              values: aStatus,
              current: value,
              style: {
                top: rect.bottom,
                left: rect.left,
                width: rect.width,
                backgroundColor: style.backgroundColor,
                color: style.color,
              },
              callBackClose: function () {
                self.column_preview = false;
                self.$comboSelector.close();
              },
              callBackSave: function (status) {
                var status1 = "";
                var status2 = "";
                for (var k in aStatus) {
                  var stat = aStatus[k];
                  if (stat.id == value) status1 = stat.name;
                  else if (stat.id == status) status2 = stat.name;
                }

                self.$popup.confirm(
                  {
                    message: i18n
                      .t("participants.lottery_send_change")
                      .replace("{status1}", i18n.t(status1))
                      .replace("{status2}", i18n.t(status2)),
                    btnSuccess: i18n.t("accept"),
                    btnError: i18n.t("cancel"),
                  },
                  function () {
                    self.$overlay.loading();
                    var path = "persons/changeLotterySend";
                    self.$store
                      .dispatch(path, {
                        id: id.split("_")[0],
                        event_id:
                          self.$store.getters["events/getCurrentEvent"]().id,
                        lottery_send: status,
                      })
                      .then(function () {
                        self.column_preview = false;
                        self.$comboSelector.close();
                        self.$store
                          .dispatch(
                            "events/loadByName",
                            self.$route.params.event
                          )
                          .then(function () {
                            self.$overlay.hide();
                          });
                      });
                  },
                  function () {
                    self.column_preview = false;
                    self.$comboSelector.close();
                  }
                );
              },
            });

            break;

          case "assign_team":
            e.preventDefault();
            e.stopPropagation();
            var self = this;
            this.$card.assignTeamToTmpl({
              tmpl_team_id: id.substring(2).split("_")[0],
              team_id: value != null ? value.id : -1,
              item: item,
              event_id: self.$store.getters["events/getCurrentEvent"]().id,
              callBack: function (plug, params, store) {
                //console.log(plug);
                self.$store
                  .dispatch("competition/assignTeamToTmpl", {
                    team_id: plug.params.team.value,
                    tmpl_team_id: plug.params.tmpl_team.value,
                    item: plug.params.item,
                  })
                  .then(function () {
                    self.$popup.alert({
                      message: i18n.t("competition.group.assign_team_to_tmpl"),
                      btnSuccess: i18n.t("accept"),
                    });
                    self.$card.close();
                    self.$emit("reload");
                  })
                  .catch(function (e) {
                    //console.log(e);
                    self.$popup.alert({
                      message: i18n.t("errors." + e),
                      btnSuccess: i18n.t("accept"),
                    });
                    self.$card.close();
                  });
              },
            });
            break;
          case "tmpl_team":
            e.preventDefault()
            e.stopPropagation()

            var self = this;
            //console.log(id, data);
            this.$card.assignTeamToTmpl({
                tmpl_team_id: value.id,
                team_id: value.team != null ? value.team.id : -1,
                item: {category_id: item.category_id, category: item.category},
                event_id: self.$store.getters["events/getCurrentEvent"]().id,
                is_groups: false,
                callBack: function (plug, params, store) {
                    //console.log(plug);
                    self.$store
                    .dispatch("competition/assignTeamToTmpl", {
                        team_id: plug.params.team.value,
                        tmpl_team_id: plug.params.tmpl_team.value,
                        item: plug.params.item,
                    })
                    .then(function () {
                        self.$popup.alert({
                        message: i18n.t("competition.match.assign_team_to_tmpl"),
                        btnSuccess: i18n.t("accept"),
                        });
                        self.$card.close();
                        self.$emit("reload");
                    })
                    .catch(function (e) {
                        self.$popup.alert({
                        message: i18n.t("errors." + e),
                        btnSuccess: i18n.t("accept"),
                        });
                        self.$card.close();
                    });
                },
            });

          default:
            break;
        }
      }
    },
    applyFilters(bForce) {
      // console.log( "--- APPLY FILTERS ---" )
      // console.log( this.current_filters_values );
      var filters = { ...this.current_filters_values };
      var bForce = typeof bForce !== "undefined" ? bForce : false;

      this.$store.commit("navigation/setCurrentFilters", {
        page: this.$store.getters.getCurrentPage,
        event: this.$store.getters.isEventSelected,
        filters: filters,
      });

      var oFilters = {};
      // console.log( this.filters );
      for (var i in filters) {
        var filter = filters[i];
        for (var j in this.filters) {
          if (
            i == "status" ||
            bForce ||
            (i == this.filters[j].param &&
              filter != this.filters[j].current_value)
          ) {
            oFilters[i] = filter;
          }
        }
      }
      // console.log( oFilters )
      this.$emit(
        "applyFilters",
        Object.keys(oFilters).length > 0 ? oFilters : false
      );
    },
    resetFilters() {
      var filters = [...this.filters];
      var current_filters = { ...this.current_filters_values };
      filters.forEach((filter) => {
        // if ( filter.current_value == '-1' || filter.current_value == '' || filter.current_value.startsWith('{')) {
        //   current_filters[filter.param] = filter.current_value;
        // } else {
        current_filters = {};
        // }
      });

      // this.current_filters_values = current_filters;
      this.$store.commit("navigation/setCurrentFilters", {
        page: this.$store.getters.getCurrentPage,
        event: this.$store.getters.isEventSelected,
        filters: current_filters,
      });
      this.$emit("applyFilters", current_filters);

      this.$store.commit("navigation/setCurrentFilters", {
        page: this.$store.getters.getCurrentPage,
        event: this.$store.getters.isEventSelected,
        filters: {},
      });
    },

    getOptions(options, filter) {
      if (typeof options === "string") {
        var aOptions = [];
        // console.log(options);
        // console.log(filter);
        if (typeof filter.params !== "undefined") {
          if (filter.params == "{COMPETITION_CATEGORY_ID}") {
            filter.params =
              this.$store.getters["competition/getCategorySelected"];
          }

          if (filter.params == "{CURRENT_EVENT_TYPE_ID}") {
            filter.params =
              this.$store.getters["events/getCurrentEvent"]().type_id;
          }

          var values = this.$store.getters[options](filter.params);
        } else {
          var values = this.$store.getters[options]();
        }
        // console.log(values);
        aOptions.push({ value: -1, text: i18n.t(filter.label) });
        for (var i in values) {
          var value = values[i];
          //   console.log(value);
          var name =
            typeof filter.translate === "undefined" || filter.translate
              ? i18n.t(value.name)
              : value.name;
          aOptions.push({ value: value.id, text: name });
        }
        // console.log(aOptions);
        return aOptions;
      } else {
        // console.log("options", options);
        options.forEach((option) => {
          option.text = i18n.t(option.text);
        });
        return options;
      }
    },

    getIDsVisible() {
      // var rows = document.getElementsByClassName( 'datatable-container' )[0].getElementsByClassName( 'item' );
      // var sIDs = "";
      // for( var i = 0; i < Object.keys( rows ).length; i++ ) {
      //     if( sIDs != "" ) sIDs+= ',';
      //     sIDs+= rows[ i ].dataset.id;
      // }
      var rows = this.values;
      var sIDs = "";
      rows.forEach((row) => {
        if (sIDs != "") sIDs += ",";
        sIDs += row.id;
      });

      return sIDs;
    },

    getColumnsVisible() {
      var headers = [];
      var self = this;
      this.schema.forEach((raw) => {
        // console.log(this.hidden_columns.indexOf(raw.id));
        if (self.hidden_columns.indexOf(raw.param) == -1) {
          var column = {
            text: raw.label,
            param: raw.param,
            sortable: typeof raw.sortable !== "undefined" ? raw.sortable : true,
            type: raw.type,
            blocked: false,
            width: typeof raw.width !== "undefined" ? raw.width : "",
            only_event: raw.only_event,
            only_global: raw.only_global,
          };
          headers.push(column);
        }
      });

      return headers;
    },

    getValue(item, param) {
      var aSubElements = param.split(".");
      var aux = item;
      // console.log( "--- getValue ---" );
      // console.log( "-- param: " + param + " --" );
      aSubElements.forEach((sub) => {
        // console.log( aux );
        aux = aux[sub];
      });
      // console.log( aux );

      return aux;
    },

    edit_status(id, e) {
      e.preventDefault();
      e.stopPropagation();
      // alert( "UPDATE STATUS" );
    },

    destroyElement() {
      // alert( "DESTROY TABLE" )
      this.$forceUpdate();
      var self = this;
      if (this.page_name == "event_competition_scoreboard_phase") {
        let interval = setTimeout(function () {
          if (document.getElementsByClassName("arrow-up").length > 0) {
            clearTimeout(interval);

            var elements = document.getElementsByClassName("arrow-up");
            for (var i = 0; i < elements.length; i++) {
              elements[i].addEventListener("click", function (e) {
                e.stopPropagation();
                e.preventDefault();

                var id = e.target.parentElement.getAttribute("id");
                id = id.split("_")[0];
                let tmpl_team_id = self.data.data.filter((t) => {
                  return t.id == id;
                })[0].tmpl_team_id;

                var page = "competition/scoreboard_phase";
                self.$store
                  .dispatch(page + "/update_order", {
                    id: tmpl_team_id,
                    order: "up",
                    event_id:
                      self.$store.getters["events/getCurrentEvent"]().id,
                  })
                  .then((response) => {
                    self.readDataFromAPI();
                  });
              });
            }
            var elements2 = document.getElementsByClassName("arrow-down");
            for (var i = 0; i < elements2.length; i++) {
              elements2[i].addEventListener("click", function (e) {
                e.stopPropagation();
                e.preventDefault();

                var id = e.target.parentElement.getAttribute("id");
                id = id.split("_")[0];
                let tmpl_team_id = self.data.data.filter((t) => {
                  return t.id == id;
                })[0].tmpl_team_id;

                var page = "competition/scoreboard_phase";
                self.$store
                  .dispatch(page + "/update_order", {
                    id: tmpl_team_id,
                    order: "down",
                  })
                  .then((response) => {
                    self.readDataFromAPI();
                  });
              });
            }
          }
        }, 5000);
      }
    },

    fnDestroy() {
      this.$destroy();
    },

    readDataFromAPI() {
      this.$parent.$data.loading = true;
      let pagination = { ...this.pagination };
      pagination.rowsPerPage = this.options.itemsPerPage;
      this.pagination = { ...pagination };

      this.$emit("loadData", {
        num_page: this.options.page - 1,
        num_items: this.options.itemsPerPage,
      });
    },

    sortTable(items, sortBy, sortDesc, locale, customSorters) {
      var self = this;
      if (
        this.page_name != "event_competition_groups" &&
        this.page_name != "event_competition_calendar" &&
        this.page_name != "event_competition_scoreboard" &&
        this.page_name != "event_competition_scoreboard_phase" &&
        this.page_name != "event_competition_stats_top_scores" &&
        this.page_name != "event_competition_stats_team_scores" &&
        this.page_name != "event_competition_sanctions" &&
        this.page_name != "event_competition_injuries" &&
        this.page_name != "event_competition_matchs"
      ) {
        items.sort((i1, i2) => {
          if (typeof i1.inscription_date !== "undefined") {
            self.pagination.sortBy = "inscription_date";
            self.pagination.descending = true;
            if (
              moment(i1.inscription_date).valueOf() >
              moment(i2.inscription_date).valueOf()
            ) {
              return -1;
            }
          } else if (
            typeof i1.user_modify !== "undefined" &&
            (this.page_name == "volunteers" ||
              this.page_name == "event_volunteers")
          ) {
            self.pagination.sortBy = "user_modify";
            self.pagination.descending = true;

            if (
              moment(i1.user_modify.date).valueOf() >
              moment(i2.user_modify.date).valueOf()
            ) {
              return -1;
            }
          } else {
            if (this.page_name == "event_competition_matchs") {
              var i1_name = parseInt(i1.name.split(".")[1]);
              var i2_name = parseInt(i2.name.split(".")[1]);

              if (i1_name < i2_name) return -1;
            } else {
              if (i1.name < i2.name) return -1;
            }
          }
          return 1;
        });
      }

      return items;
    },
    updateGroup(id) {
      var self = this;
      let checking = self.data.data.filter((t) => {
        return t.type && t.type == "category" && t.id == id;
      })[0].checking;
      this.$store
        .dispatch("competition/groups/updateGroup", {
          id: id,
          event_id: self.$store.getters["events/getCurrentEvent"]().id,
          checking: checking ? 1 : 0,
        })
        .then((response) => {
          self.readDataFromAPI();
        });
    },
  },
  watch: {
    options: {
      handler() {
        this.readDataFromAPI();
      },
      deep: true,
    },
    $route: "destroyElement",
  },
  created() {
    var self = this;
    var page = this.page_name.replace("event_", "");
    if (page == "finances") {
      this.pagination = {
        sortBy: "status",
        rowsPerPage: -1,
        descending: false,
      };
    }
  },

  mounted() {
    var self = this;
    this.$overlay.loading();

    setTimeout(function () {
      // self.applyFilters( true )
    }, 300);
  },
};
</script>

<style lang="scss">
.full_separator {
  .table-view {
    .filter-column {
      height: calc(100% - 170px);
    }
  }
}
.table-view {
  width: 100%;
  height: calc(100% - 10px);
  overflow: auto;
  position: relative;
  top: 10px;

  top: 0px;
  height: 100%;

  .filter-column {
    float: left;
    width: 20%;
    border-right: 1px solid #ccc;
    height: 100%;
    background-color: #fff;
    transition: width 1s;
    display: inline-block;
    position: absolute;

    height: calc(100% - 110px);
    position: fixed;

    &.hide {
      width: 0%;
      padding: 0px;
      position: absolute;
      transition: width 1s;

      .filters {
        opacity: 0;
      }

      .filter-buttons {
        opacity: 0;
      }
    }

    .filters {
      padding: 0px 25px;
      height: calc(100% - 20px - 70px);
      overflow: auto;
      border-bottom: 1px solid #eee;
      overflow-x: hidden;

      .filter {
        .title {
          font-size: 14px !important;
          text-transform: capitalize;
          display: none;
        }

        .value {
          margin: 5px 0;

          .v-input__slot {
            border: none;
            border-bottom: 2px solid rgba(0, 0, 0, 0.08);
            border-radius: 0;
            padding-left: 0;

            &:hover {
              border: none !important;
              border-bottom: 2px solid rgba(0, 0, 0, 0.08) !important;
            }
          }

          .v-select__slot {
            border-bottom: 0;
          }

          .v-input__control {
            width: 100%;
          }

          label {
            text-transform: capitalize;
            font-size: 14px;
          }
          .v-input__prepend-inner {
            margin-top: 25px;
          }
        }

        .v-menu__content {
          position: fixed !important;
        }
        .v-select {
          label {
            text-transform: capitalize;
            top: 0px;
            padding-left: 0;
            font-size: 14px;
            /*display: none;*/
          }
        }

        .filter-checkbox {
          display: inline-block;
          width: 30px;
          margin-top: 21px;
          float: left;

          .v-input__slot {
            border: none !important;
          }
        }

        .filter-input {
          //margin-left: 30px;
          display: inline-block;
          width: calc(100% - 30px);
        }
      }
    }

    .filter-buttons {
      height: 82px;
      position: absolute;
      bottom: 0px;
      width: 100%;

      .bttn {
        width: 40% !important;
        margin: 10px 5% !important;
        display: inline-block;
        text-transform: none;
        height: 28px;
        background-color: white !important;
        border: 1px solid #aaa;
        border-radius: 5px;
        color: #444 !important;
        font-size: 15px !important;

        &.action {
          background-color: #8bc34a !important;
          color: #fff !important;
        }

        /*&.do_filter {
          background-color: $complem-color !important;
          color: #fff;
        }*/
        &.reset {
          border: none;
          color: #aaa !important;

          .v-btn__content {
            font-size: 14px;
          }
        }
      }
    }
    .hide-filter {
      position: absolute;
      top: calc(50% - 70px);
      left: 100%;
      z-index: 10;
      background-color: #bbb;
      overflow: hidden;
      width: 15px;
      height: calc(15px + 2 * 12px);
      opacity: 0.5;
      padding: 12px 0;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      img {
        -webkit-transition: -webkit-transform 0.5s ease-in-out;
        transition: transform 0.5s ease-in-out;

        &.hide {
          -webkit-transition: -webkit-transform 0.5s ease-in-out;
          transition: transform 0.5s ease-in-out;
          -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
          left: 0%;
        }
      }
    }
  }

  .data-column {
    float: right;
    width: 80%;
    height: 100%;
    transition: width 1s, height 4s;

    &.hide {
      float: right;
      width: 100%;
      margin-left: 0%;
      transition: width 1s, height 4s;
    }

    &.large {
      width: 100%;
      margin-left: 0;
    }

    .datatable-container {
      table-layout: fixed;
      height: calc(100% - 60px);

      .v-table__overflow {
        height: 100% !important;
        overflow-y: auto;
      }

      &.no-footer {
        height: 100%;
      }

      &.no-header {
        thead {
          //display: none !important;
          opacity: 0 !important;
        }
      }
    }
    table.v-table {
      table-layout: fixed;
      // width: 200% !important;
      max-width: 100% !important;
      max-height: 100%;
    }
    .v-table {
      thead {
        border-bottom: 0px solid #eee;
        border-collapse: collapse;
        width: 100%;
        flex: 1;
        z-index: 999999;

        tr {
          height: 20px;

          th.column {
            background-color: #ddd;
            text-align: left;
            text-transform: uppercase;
            overflow: hidden;
            text-overflow: ellipsis;
            display: table-cell;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;

            position: sticky;
            top: 0;
            z-index: 9;
          }
        }
      }

      tbody {
        .col-icon {
          padding: 15px 12px;
        }

        .table-category {
          padding: 0px;
          padding-left: 20px;
          background-color: #333;
          color: #f1f1f1;
          text-transform: uppercase;
          font-weight: bold;
          font-size: 18px;
          border-bottom: 1px solid;
          border-top: 1px solid;
          font-family: $text-bold;

          .v-input:not(.v-input--radio-group) .v-input__slot {
            border-bottom: none !important;
          }
          .v-input--switch .v-input--selection-controls__input {
            width: 30px !important;
          }
          .v-input--switch__track {
            height: 10px !important;
          }
          .v-input--switch__thumb {
            height: 16px !important;
            width: 16px !important;
          }
          .v-label {
            font-size: 12px !important;
            color: #fff !important;
          }
          label {
            margin: 0 !important;
          }
          .v-input__slot {
            margin-bottom: 0 !important;
          }
          .v-messages {
            display: none !important;
          }
        }

        tr:hover:not(.v-datatable__expand-row) {
          background: #f9c10838;
        }

        .column {
          text-align: left;
          font-size: 14px;
          //text-overflow: ellipsis;
          //white-space: nowrap;
          overflow: hidden;
          padding: 10px 5px;

          &.bold {
            font-family: $text-bold;
          }

          &[data-type="image"] {
            padding: 0;
          }

          .country {
            font-size: 14px;

            img {
              height: 30px;
              width: auto;
              margin-top: 5px;
            }

            .label {
              font-weight: bold;
            }
          }

          .club,
          .entity,
          .facility {
            font-size: 13px;
            line-height: 15px;
            display: flex;
            vertical-align: middle;
            align-items: center;
            border-radius: 4px;
            background-color: #fff;
            padding: 5px;

            img {
              float: left;
              margin-right: 5px;
              margin-top: 0px;
            }
          }

          .entity {
            border-left: 4px solid transparent;
            &.winner {
              border-left: 4px solid #ffc107;
              padding-left: 10px;
            }
          }

          &[data-type="status"][data-value="1"] {
            @include background($image: img("checked_ok.svg"), $size: 25px);
          }

          .completition-status {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            text-align: left;
            font-size: 14px;
            color: #333;

            .pending {
              width: 10px;
              height: 10px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 100%;
              background-color: #ccc;
            }

            .error {
              width: 10px;
              height: 10px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 100%;
              background-color: #f00;
            }

            .complete {
              width: 10px;
              height: 10px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 100%;
              background-color: rgb(32, 184, 65);
            }
          }

          .role {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            text-align: left;
            font-size: 14px;
            color: #333;

            .icon {
              width: 10px;
              height: 10px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 100%;
              background-color: #ccc;
            }

            &.r1 {
              .icon {
                background-color: $bg-role-1;
              }
            }
            &.r2 {
              .icon {
                background-color: $bg-role-2;
              }
            }
            &.r5 {
              .icon {
                background-color: $bg-role-5;
              }
            }
            &.r6 {
              .icon {
                background-color: $bg-role-6;
              }
            }
            &.r107 {
              .icon {
                background-color: $bg-role-107;
              }
            }
            &.r108 {
              .icon {
                background-color: $bg-role-108;
              }
            }
            &.r109 {
              .icon {
                background-color: $bg-role-109;
              }
            }
            &.r110 {
              .icon {
                background-color: $bg-role-110;
              }
            }
            &.r111 {
              .icon {
                background-color: $bg-role-111;
              }
            }

            & .value {
              font-size: 18px;
              text-transform: uppercase;
            }
          }

          .user {
            border-radius: 15px;
            padding: 5px 15px;
            font-weight: lighter;
            margin: 0 auto;
            text-align: center;
            position: relative;
            border: 2px solid #ddd;
            max-width: 200px;
            font-size: 14px;
            background-color: #fff;

            &:not(.no_modify)::after {
              content: " ";
              @include background($image: img("down.svg"), $size: 15px);
              position: absolute;
              right: 15px;
              top: 10px;
              width: 10px;
              height: 10px;
            }
          }

          .competition_phase {
            font-weight: bold;
            width: 300px;
            float: left;
          }

          &[data-type="status"] {
            text-align: center !important;
          }

          .status {
            border-radius: 15px;
            padding: 5px 20px;
            font-weight: lighter;
            margin: 0 auto;
            text-align: left;
            position: relative;
            font-size: 14px;
            border: 2px solid #ddd;
            max-width: 200px;
            text-align: center;
            background-color: #fff;

            .icon {
              width: 10px;
              height: 10px;
              display: inline-block;
              margin-right: 10px;
              border-radius: 100%;
            }

            &:not(.disabled)::after {
              content: " ";
              @include background($image: img("down.svg"), $size: 15px);
              position: absolute;
              right: 15px;
              top: 10px;
              width: 10px;
              height: 10px;
            }
          }

          .budget.pending {
            background-color: #ff3333;
            color: #fff;
            font-weight: bold;
            text-align: center;
            border-radius: 4px;
            font-family: $text-bold;
            padding: 2px;
          }
          .budget.over {
            background-color: #f1c232;
            font-weight: bold;
            text-align: center;
            border-radius: 4px;
            font-family: $text-bold;
            padding: 2px;
          }

          img {
            height: 25px;
            width: auto;
            margin-top: 5px;

            &.logo_event {
              background: rgb(130, 127, 139);
            }
          }

          .status-event-list {
            position: fixed;
            z-index: 100;
            background-color: #172654;
            width: 225px;

            .item {
              color: #fff;
              padding: 5px 10px;
              cursor: pointer;

              &:not(:first-child) {
                border-top: 1px solid #acacac;
              }
            }
          }

          .entity.team {
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            /* line-height: 34px; */
            display: flex;
            align-items: center;

            & .logo {
              margin-right: 10px;
            }
          }

          .overbooking {
            font-weight: bold;
            color: #c51818;
          }

          .icon.arrow-up {
            content: " ";
            width: 18px;
            height: 18px;
            background-image: url(/img/arrow-up.svg);
            display: inline-block;
            cursor: pointer;
            margin-left: 20px;
          }
          .icon.arrow-down {
            content: " ";
            width: 18px;
            height: 18px;
            background-image: url(/img/arrow-down.svg);
            display: inline-block;
            cursor: pointer;
          }
        }
      }
    }

    #table-pagination {
      width: 100%;
      height: 60px;
      display: flex;
      line-height: 60px;
      background: #ddd;
      font-size: 14px;
      overflow: hidden;

      .totalItems {
        font-size: 14px;
        width: 33%;
        line-height: 60px;
        padding-left: 10px;
        text-align: left;

        span.filtered {
          font-size: 14px;
          font-weight: bold;
          color: #676565;
        }
        span.total {
          font-size: 14px;
          font-weight: bold;
        }
      }
      .pagination {
        width: 45%;
        padding: 6px 0px;
        margin: 0 auto;
        text-align: center;

        .v-pagination .v-pagination__navigation {
          box-shadow: none;
        }

        .v-pagination .v-pagination__item {
          background: #ddd;
          color: #888;
          box-shadow: none;

          &.v-pagination__item--active {
            background: #fff;
            color: #000;
            box-shadow: none;
          }
        }
      }

      .rows-page {
        text-align: center;
        width: 32%;
        padding: 2px 35px;

        .v-input {
          max-width: 200px;
          text-align: center;
          margin: 0 auto;
        }
      }
    }
  }
}

.development {
  .table-view {
    .data-column {
      .datatable-container {
        table-layout: fixed;
        height: calc(100% - 60px - #{$height-development});
      }
    }
  }
}

.table-category {
}

.table-view.portrait {
  .filter-column.portrait {
    &.show {
      width: 90%;
      z-index: 19;
      margin-top: 0px;
    }

    .hide-filter {
      width: 20px;
      height: calc(20px + 2 * 12px);
      opacity: 0.8;
    }
  }
  #table-pagination {
    .totalItems {
      line-height: 16px;
      padding-top: 12px;
    }

    .pagination {
      overflow: hidden;

      li:not(:first-child):not(:last-child) {
        display: none !important;
      }
    }
  }
}
</style>
